// 埋点页面链接：https://stream.jd.com/ddrx/#/requirement/25158
// WARNING!!! 请勿手动修改此文件，如需修改请在子午线平台变更后，执行npm run track-init 25158 
import { eventTrackingUtils } from '@/utils/eventTrackingUtils'
export const PageId = Object.freeze({
  Activity_Yqyl: 'Activity_Yqyl'
})

interface IPVTrackParamsRecord {
  /** 邀请有礼活动页 */
Activity_Yqyl: {
/** 邀请码  */
invite_code: string}
}

const sendPv = {
  /** PV-邀请有礼活动页 */
Activity_Yqyl: (page_param: IPVTrackParamsRecord['Activity_Yqyl']) => {
    eventTrackingUtils.submitPV({page_id:PageId.Activity_Yqyl,page_param});
  },
}

interface IExpoTrackParamsRecord {
  /** 邀请弹窗曝光 */
Activity_Yqyl_InviteExpo: {
/** 优惠券id  */
couponId: string,
/** 优惠券批次号  */
batchId: string,
/** 优惠券金额  */
couponSave: string,
/** 优惠券使用门槛  */
use_threshold: string,
/** 券类型 1-普通券,2-新人券 */
couponType: | '1'| '2',
/** 优惠券数量  */
couponNum: string}
  /** 邀请有礼规则弹窗曝光 */
Activity_Yqyl_Rules_Expo: undefined
}

const EXPOSURE_RECORD: Readonly<Record<keyof IExpoTrackParamsRecord,string>> = Object.freeze({
/** 邀请弹窗曝光 */
  Activity_Yqyl_InviteExpo:'Activity_Yqyl_InviteExpo',
/** 邀请有礼规则弹窗曝光 */
  Activity_Yqyl_Rules_Expo:'Activity_Yqyl_Rules_Expo',
})

interface IClickTrackParamsRecord {
  /** 邀请按钮点击 */
Activity_Yqyl_Invite: {
/** 优惠券批次号  */
batchId: string,
/** 优惠券使用门槛  */
use_threshold: string,
/** 券类型 1-普通券,2-新人券 */
couponType: | '1'| '2',
/** 优惠券金额  */
couponSave: string,
/** 优惠券id  */
couponId: string,
/** 优惠券数量  */
couponNum: string}
  /** 邀请分享渠道点击 */
Activity_Yqyl_Share_Channel: {
/** 按钮名称  */
button_name: string}
}

const sendClickTrack = {
  /** 点击事件上报-邀请按钮点击 */
Activity_Yqyl_Invite: (json_param: IClickTrackParamsRecord['Activity_Yqyl_Invite']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_Yqyl_Invite',json_param});
  },
  /** 点击事件上报-邀请分享渠道点击 */
Activity_Yqyl_Share_Channel: (json_param: IClickTrackParamsRecord['Activity_Yqyl_Share_Channel']) => {
    eventTrackingUtils.submitCL({event_id:'Activity_Yqyl_Share_Channel',json_param});
  },
}

export {
  EXPOSURE_RECORD,
  sendClickTrack,
  sendPv,
}
export type {
  IExpoTrackParamsRecord,
}